import React, { useState, useEffect } from "react"
import CardLink from "./components/CardLink"
import { Col, Row, Space } from "antd"
import BusinessForm from "./components/BusinessForm"
import SuccessModal from "./components/SuccessModal"

const Links = [
  {
    icon: "https://wwww.alsendo.lt/imgs/business_page/percentage.svg",
    title: "Nuolaidos verslo klientams",
    text: "Siunčiantiems siuntas nuolat- nuolaidos ir specialūs pasiūlymai. Kuo daugiau siuntų, tuo mažesnės kainos.",
    link: "#",
  },
  {
    icon: "/imgs/business_page/calculator.svg",
    title: "Kainų skaičiuoklė",
    text: "Kainų skaičiuoklėje kelių mygtukų paspaudimu gaukite visų kurjerių gabenimo pasiūlymus vienoje  vietoje.",
    link: "/",
  },
  {
    icon: "/imgs/business_page/gear.svg",
    title: "Patogi siuntų valdymo sistema",
    text: "Siuntų užsakymas, sekimas bei apmokėjimas vienoje lengvai valdomoje  savitarnos platformoje.",
    link: "/how_it_works",
  },
  {
    icon: "/imgs/business_page/globe.svg",
    title: "Platus kurjerių pasirinkimas",
    text: "Patikimiausių ir žinomiausių kurjerių kompanijų paslaugos vienoje vietoje į daugiau nei 200 šalių.",
    link: "/terms_couriers_pages/kurjeriu-paslaugos",
  },
  {
    icon: "/imgs/business_page/api.svg",
    title: "API integracija e-parduotuvėms",
    text: "Alsendo ir elektroninės parduotuvės sąsaja API pagalba. Paprastas ir greitas užsakymų valdymas.",
    link: "/terms_couriers_pages/api-integracija",
  },
  {
    icon: "/imgs/business_page/trolley.svg",
    title: "E-parduotuvių sąsajos",
    text: "Populiariausių prekybos platformų ir prekyviečių, tokių kaip EBAY, ETSY, SHOPIFY, integracijos vienoje vietoje.",
    link: "https://www.alsendo.lt/integracijos",
  },
]

const LinksSection = () => {
  const [isFormModalVisible, setIsFormModalVisible] = useState(false)
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false)
  return (
    <>
      <div
        className="margin-100-zero"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <Row gutter={[32, 32]} style={{ maxWidth: 1200 }}>
          {Links.map((link) => (
            <Col span={24} md={{ span: 12 }} xl={{ span: 8 }} key={link.title}>
              {link.title == "Nuolaidos verslo klientams" ? (
                <>
                  <div
                    className="card-link"
                    onClick={() => setIsFormModalVisible(true)}
                  >
                    <div
                      style={{
                        margin: "20px 20px 0px 20px",
                        padding: "20px 20px 0px 20px",
                      }}
                    >
                      <Space style={{ marginBottom: 15 }}>
                        <img src={link.icon} />
                        <div className="card-title-font">{link.title}</div>
                      </Space>
                      <div className="text-font" style={{ textAlign: "left" }}>
                        <p>{link.text}</p>
                      </div>
                    </div>
                  </div>
                  {isFormModalVisible && (
                    <BusinessForm
                      setIsFormModalVisible={setIsFormModalVisible}
                      setIsSuccessModalVisible={setIsSuccessModalVisible}
                    />
                  )}
                  {isSuccessModalVisible && (
                    <SuccessModal
                      setIsSuccessModalVisible={setIsSuccessModalVisible}
                    />
                  )}
                </>
              ) : (
                <CardLink link={link} />
              )}
            </Col>
          ))}
        </Row>
      </div>
    </>
  )
}

export default LinksSection
